export function setCookie(key, value, exp) {
  if (value == null || value == '') {
    return
  }
  // prevent port inside domain
  const domain = window.location.hostname

  if (exp < new Date()) {
    return (document.cookie =
      key +
      '=' +
      value +
      '; max-age=max-age-in-seconds=' +
      -1 +
      '; path=/; secure; domain=' +
      domain)
  }
  document.cookie =
    key +
    '=' +
    value +
    '; max-age=max-age-in-seconds=' +
    exp +
    '; path=/; secure; domain=.' +
    domain
}
export function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }